import React, { useEffect, useState, useMemo } from "react";
import { emiOverdueListNewApi, updateOverdueExpectedDetails, downloadAllOverdueEmiListRpeortData, getEMiDataByEMiId } from "../AdminActionCreator.component";
import Popup from '../../../presentationals/Popup/Popup.component';
import Pagination from '@mui/material/Pagination';
import Loader from '../../../presentationals/Loader/Loader.component';
import NodataImage from '../../../../images/nodata.png';
import moment from "moment";
import { ChevronsUpDown } from "lucide-react";
import GenerateLink from "../../../presentationals/Popup/GeneratePaymentLinkPopup/Main.js";
import { CheckFunction } from "../../../../layouts/MainTenantconfig.js";

// ─── Bucket Config ────────────────────────────────────────────────────────────
const BUCKET_TABS = [
    { key: "0-30", label: "0–30 DPD", color: "#ff947a", bg: "#fff4de", icon: "fa-clock-o" },
    { key: "31-60", label: "31–60 DPD", color: "#dbb328", bg: "#fff1c1", icon: "fa-exclamation-circle" },
    { key: "61-90", label: "61–90 DPD", color: "#ea580c", bg: "#ffedd5", icon: "fa-exclamation-triangle" },
    { key: "90+", label: "90+ DPD", color: "#dc2626", bg: "#fee2e2", icon: "fa-times-circle" },
    { key: "overall", label: "Overall", color: "#fa5a7d", bg: "#ffe2e6", icon: "fa-cart-arrow-down" }
];

const fmtINR = (n) => Number(n || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtCnt = (n) => Number(n || 0).toLocaleString('en-US');

const getBucketStyles = (bucketKey) => {
    const tab = BUCKET_TABS.find(t => t.key === bucketKey);
    if (tab) {
        return { color: tab.color, backgroundColor: tab.bg };
    }
    return { color: "#64748b", backgroundColor: "#f1f5f9" };
};

// ─── Scoped CSS Styles ────────────────────────────────────────────────────────
const cssStyles = `
.overdue-emi-dashboard {
  background: #ffffff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(148, 163, 184, 0.06);
  margin-top: 15px;
  margin-bottom: 30px;
}

.overdue-emi-dashboard .dashboard-header-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  border-bottom: 1px solid #f1f5f9;
  padding-bottom: 16px;
}

.overdue-emi-dashboard .dashboard-title-area {
  display: flex;
  align-items: center;
  gap: 14px;
}

.overdue-emi-dashboard .dashboard-title-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #fee2e2 0%, #fca5a5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #dc2626;
}

.overdue-emi-dashboard .dashboard-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
}

.overdue-emi-dashboard .dashboard-subtitle {
  margin: 2px 0 0 0;
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.overdue-emi-dashboard .filter-card {
  background: #f8fafc;
  border: 1px solid #f1f5f9;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 24px;
}

.overdue-emi-dashboard .filter-card label {
  font-size: 11px;
  font-weight: 700;
  color: #64748b;
  margin-bottom: 6px;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.overdue-emi-dashboard .form-control {
  border-radius: 8px;
  border: 1px solid #cbd5e1;
  background-color: #ffffff;
  padding: 8px 12px;
  font-size: 13px;
  font-weight: 500;
  color: #1e293b;
  height: 38px;
  transition: all 0.2s ease;
  box-shadow: none;
}

.overdue-emi-dashboard .form-control:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background-color: #ffffff;
  outline: none;
}

.overdue-emi-dashboard .action-btn {
  font-weight: 600;
  font-size: 13px;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-top: 22px;
}

.overdue-emi-dashboard .filter-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  border: none;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.15);
}

.overdue-emi-dashboard .filter-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.25);
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
}

.overdue-emi-dashboard .download-btn {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
  box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.overdue-emi-dashboard .download-btn:hover {
  background: #f8fafc;
  color: #1e293b;
  border-color: #94a3b8;
  transform: translateY(-1px);
}

.overdue-emi-dashboard .summary-table-container {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.02);
  margin-bottom: 32px;
  overflow-x: auto;
}

.overdue-emi-dashboard .summary-table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.overdue-emi-dashboard .summary-table th {
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 14px 16px;
  border-bottom: 2px solid #e2e8f0;
}

.overdue-emi-dashboard .summary-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  cursor: pointer;
  transition: all 0.2s ease;
  vertical-align: middle;
}

.overdue-emi-dashboard .summary-table tr:hover td {
  background-color: #f8fafc;
}

.overdue-emi-dashboard .summary-table tr.row-active td {
  background-color: var(--active-bg-color) !important;
  font-weight: 700;
}

.overdue-emi-dashboard .summary-table tr.row-active td:first-child {
  border-left: 4px solid var(--active-color) !important;
}

.overdue-emi-dashboard .summary-category-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.overdue-emi-dashboard .summary-icon-wrapper {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.overdue-emi-dashboard .summary-metric-val-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
}

.overdue-emi-dashboard .summary-val {
  font-size: 13px;
  color: #1e293b;

}

.overdue-emi-dashboard .summary-cnt-badge {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  background: #e2e8f0;
  padding: 1px 5px;
  border-radius: 6px;
  width: max-content;
}

.overdue-emi-dashboard .summary-table tr.row-active .summary-cnt-badge {
  background: rgba(255, 255, 255, 0.4);
}

.overdue-emi-dashboard .summary-viewing-badge {
  background: #10b981;
  color: white;
  font-size: 9px;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 4px rgba(16, 185, 129, 0.15);
  margin-left: auto;
}

.overdue-emi-dashboard .summary-table tr.total-row td {
  background: #f8fafc;
  border-top: 2px solid #e2e8f0;
  border-bottom: none;
  font-weight: 700;
}

.overdue-emi-dashboard .summary-table tr.total-row:hover td {
  background: #f1f5f9;
}

.overdue-emi-dashboard .payments-table-container {
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0,0,0,0.02);
  margin-bottom: 20px;
}

.overdue-emi-dashboard .payments-table-container .tablesconf {
  overflow-x: auto;
}

.overdue-emi-dashboard table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.overdue-emi-dashboard th {
  background: #f8fafc;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: 14px 16px;
  border-bottom: 1px solid #e2e8f0;
  white-space: nowrap;
}

.overdue-emi-dashboard td {
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
  vertical-align: middle;
  transition: background-color 0.15s ease;
}

.overdue-emi-dashboard tr:hover td {
  background-color: #f8fafc;
}

.overdue-emi-dashboard .info-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  background: #ffffff;
  transition: all 0.2s ease;
}

.overdue-emi-dashboard .info-btn:hover {
  background: #f1f5f9;
  color: #1e293b;
  border-color: #cbd5e1;
  transform: scale(1.05);
}

.overdue-emi-dashboard .edit-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 1px solid #e2e8f0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #0284c7;
  cursor: pointer;
  background: #ffffff;
  transition: all 0.2s ease;
}
.overdue-emi-dashboard .generate-btn {
  padding: 6px 12px;
  border-radius: 6px;
  border: 1px solid #bae6fd;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  color: #0284c7;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  background: #f0f9ff;
  transition: all 0.2s ease;
}

.overdue-emi-dashboard .generate-btn:hover {
  background: #0284c7;
  color: #ffffff;
  border-color: #0284c7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(2, 132, 199, 0.15);
}

.overdue-emi-dashboard .generate-btn:active {
  transform: translateY(0);
}

.overdue-emi-dashboard .edit-btn:hover {
  background: #f0f9ff;
  color: #0369a1;
  border-color: #bae6fd;
  transform: scale(1.05);
}

.overdue-emi-dashboard .bucket-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 100px;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.02);
}

.overdue-emi-dashboard .tenure-tag {
  display: inline-flex;
  align-items: center;
  border-radius: 100px;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background-color: #f8fafc;
  color: #64748b;
  border: 1px solid #cbd5e1;
}

.overdue-emi-dashboard .pagination-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #f1f5f9;
  flex-wrap: wrap;
  gap: 12px;
}

.overdue-emi-dashboard .pagination-info {
  font-size: 13px;
  color: #64748b;
  font-weight: 500;
}

.overdue-emi-popup {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  background: rgba(15, 23, 42, 0.4) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  z-index: 9999 !important;
}

.overdue-emi-popup .premium-popup {
  background: #ffffff !important;
  border-radius: 16px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
  padding: 30px 24px !important;
  width: 95% !important;
  max-width: 600px !important;
  position: relative !important;
  animation: modalScaleUp 0.25s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
  top: unset !important;
  left: unset !important;
  transform: unset !important;
}

@keyframes modalScaleUp {
  from {
    transform: scale(0.95);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

.overdue-emi-popup .premium-popup-close {
  position: absolute !important;
  top: 16px !important;
  right: 16px !important;
  font-size: 22px !important;
  color: #94a3b8 !important;
  cursor: pointer !important;
  transition: color 0.15s ease !important;
  float: none !important;
  margin: 0 !important;
}

.overdue-emi-popup .premium-popup-close:hover {
  color: #ef4444 !important;
}

.overdue-emi-popup .popup-title {
  margin: 0 0 6px 0 !important;
  font-size: 20px !important;
  font-weight: 800 !important;
  color: #0f172a !important;
  letter-spacing: -0.02em !important;
}

.overdue-emi-popup .popup-field-col {
  margin-top: 12px !important;
}

.overdue-emi-popup .popup-field-label {
  font-size: 11px !important;
  font-weight: 700 !important;
  color: #64748b !important;
  margin-bottom: 6px !important;
  display: block !important;
  text-transform: uppercase !important;
  letter-spacing: 0.05em !important;
}

.overdue-emi-popup .form-control {
  border-radius: 8px !important;
  border: 1px solid #cbd5e1 !important;
  background-color: #ffffff !important;
  padding: 8px 12px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: #1e293b !important;
  height: 38px !important;
  transition: all 0.2s ease !important;
  box-shadow: none !important;
}

.overdue-emi-popup .form-control:focus {
  border-color: #ef4444 !important;
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15) !important;
  outline: none !important;
}

.overdue-emi-popup .popup-submit-btn {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  border: none !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  height: 42px !important;
  padding: 0 28px !important;
  border-radius: 8px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.2) !important;
  width: auto !important;
  display: inline-block !important;
}

.overdue-emi-popup .popup-submit-btn:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 16px rgba(220, 38, 38, 0.3) !important;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%) !important;
}
`;

// ─── Component Definition ──────────────────────────────────────────────────
const OverDueEmi = ({ userDetailHandler, payload, handlePayload, admin }) => {
    const tenant = CheckFunction();
    const [currentOrder, setcurrentOrder] = useState({ order: "desc", type: "dueDate" });
    const [apiData, setApiData] = useState(null);
    const [selectedBuckets, setSelectedBuckets] = useState(["overall"]);
    const [selectedEmiSeq, setSelectedEmiSeq] = useState(-1);
    const [loaderState, setLoader] = useState(false);
    const [popupStatus, setpopupStatus] = useState('No Data Found!');
    const [popupState, setpopupState] = useState(false);

    const [startDate, setStartDate] = useState(payload?.startDate);
    const [endDate, setEndDate] = useState(payload?.endDate);
    const [startDateToShow, setStartDateToShow] = useState(payload?.startDate);
    const [endDateToShow, setendDateToShow] = useState(payload?.endDate);

    const [currentPage, setCurrentPage] = useState(1);
    const [viewPage] = useState(false);
    const itemsPerPage = 15;

    const [popupdata, setPopupdata] = useState({ show: false, data: '' });
    const [editableFields, setEditableFields] = useState({
        status: '',
        expectedDate: '',
        paymentExpectancy: ""
    });

    const [generateLinkPopup, setGnerateLinkPopup] = useState({ emiData: [], userDetail: {} })
    const [showgenerateLinkPopup, setshowGnerateLinkPopup] = useState(false)

    const handleGenerateLinkPopup = () => {
        setshowGnerateLinkPopup(false)
        setGnerateLinkPopup({ emiData: [], userDetail: {} })
    }

    const handleGeneratePopup = (data) => {
        console.log("data", data)
        setLoader(true)
        const userData = {
            loanId: data?.loanId ?? "",
            userId: data?.userId ?? "",
            mobileNumber: data?.mobileNumber ?? "",
            alternativeNo: data?.alternativeNo ?? "",
            loanEmi: data?.loanEmi ?? "",
        }
        getEMiDataByEMiId(data?.emiId, callback => {
            setLoader(false);
            console.log("cal",callback)
            if (callback && Object.keys(callback)?.length > 0) {
                const emiRecord = callback?.data ? callback.data : callback;
                setGnerateLinkPopup({  emiData: emiRecord ? [emiRecord] : [], userDetail: userData ?? {} })
                setTimeout(()=>{setshowGnerateLinkPopup(true);},200)
            } else {
                setshowGnerateLinkPopup(false)
                setGnerateLinkPopup({ emiData: [], userDetail: {} })
                setpopupState(true);
                setpopupStatus("Emi Data Not found");
                closePopup();
            }
            
        })

    }

    useEffect(() => {
        const data = {
            startDate: startDateToShow ?? "",
            endDate: endDateToShow ?? "",
            emiSeq: selectedEmiSeq,
        };
        handlePayload(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [startDate, endDate, selectedEmiSeq]);

    useEffect(() => {
        setLoader(true);
        emiOverdueListNewApi(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            currentOrder?.type,
            currentOrder?.order,
            selectedEmiSeq,
            callback => {
                setApiData(callback.data);
                if (callback?.data && callback.data.appliedEmiSeqFilter !== undefined) {
                    setSelectedEmiSeq(callback.data.appliedEmiSeqFilter);
                }
                setLoader(false);
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filterData = (seqVal = selectedEmiSeq) => {
        setLoader(true);
        emiOverdueListNewApi(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            currentOrder?.type,
            currentOrder?.order,
            seqVal,
            callback => {
                setApiData(callback.data);
                if (callback?.data && callback.data.appliedEmiSeqFilter !== undefined) {
                    setSelectedEmiSeq(callback.data.appliedEmiSeqFilter);
                }
                setLoader(false);
                setCurrentPage(1);
            }
        );
    };


    const handleDate = (value, type) => {
        if (type === 'start') {
            setStartDate(value);
            setStartDateToShow(value);
        }
        if (type === 'end') {
            setEndDate(value);
            setendDateToShow(value);
        }
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const EditData = (e, data) => {
        setPopupdata({ show: true, data: data });
        setEditableFields({
            status: data.status || '',
            expectedDate: data?.expectedDate ? moment(data.expectedDate).format('YYYY-MM-DD') : '',
            paymentExpectancy: data.paymentExpectancy || ''
        });
    };

    const closePopup = () => {
        setPopupdata({ show: false, data: "" });
        setEditableFields({
            status: "",
            expectedDate: "",
            paymentExpectancy: ""
        });
    };

    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditableFields((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const updateDetails = () => {
        setLoader(true);
        const date = moment(editableFields?.expectedDate).format("DD-MM-YYYY");
        updateOverdueExpectedDetails(
            popupdata?.data?.emiId,
            editableFields?.status,
            date,
            editableFields?.paymentExpectancy,
            (callback) => {
                setLoader(false);
                if (callback && callback?.message === "success" && callback?.status === 200) {
                    setpopupState(true);
                    setpopupStatus("Entry Updated");
                    closePopup();
                    filterData(); // Refresh the data list
                } else {
                    setpopupState(true);
                    setpopupStatus("Error: Please Try again later!");
                }
            }
        );
    };

    const removePopup = () => {
        setTimeout(() => {
            setpopupState(false);
            setpopupStatus("");
        }, 3000);
    };

    const downloaddReport = () => {
        setLoader(true);
        downloadAllOverdueEmiListRpeortData(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            callback => {
                setLoader(false);
            }
        );
    };

    const handleOrderss = (sortField, sortDirection) => {
        setcurrentOrder({ type: sortField, order: sortDirection });
        setLoader(true);
        emiOverdueListNewApi(
            moment(startDate).format('DD-MM-YYYY'),
            moment(endDate).format('DD-MM-YYYY'),
            sortField,
            sortDirection,
            selectedEmiSeq,
            callback => {
                setApiData(callback.data);
                if (callback?.data && callback.data.appliedEmiSeqFilter !== undefined) {
                    setSelectedEmiSeq(callback.data.appliedEmiSeqFilter);
                }
                setLoader(false);
                setCurrentPage(1);
            }
        );
    };

    const toggleBucket = (bucketKey) => {
        setCurrentPage(1);
        if (bucketKey === "overall") {
            setSelectedBuckets(["overall"]);
            setSelectedEmiSeq(-1);
            filterData(-1);
        } else {
            setSelectedBuckets(prev => {
                const withoutOverall = prev.filter(k => k !== "overall");
                let next = [];
                if (withoutOverall.includes(bucketKey)) {
                    next = withoutOverall.filter(k => k !== bucketKey);
                } else {
                    next = [...withoutOverall, bucketKey];
                }

                if (next.length === 0) {
                    setSelectedEmiSeq(-1);
                    filterData(-1);
                    return ["overall"];
                }
                return next;
            });
        }
    };

    // ─── Data Derivations ─────────────────────────────────────────────────────
    const displayStats = useMemo(() => {
        const stats = {};

        BUCKET_TABS.forEach(tab => {
            stats[tab.key] = {
                count: 0,
                total_amount: 0,
                total_principal: 0,
                total_interest: 0,
                total_penalty: 0,
                total_bounce: 0,
                total_overdue_interest: 0
            };
        });

        if (apiData && apiData.agingBuckets) {
            apiData.agingBuckets.forEach(bucket => {
                const key = bucket.dpdBucket;
                if (stats[key]) {
                    let bucketStats = null;
                    if (selectedEmiSeq !== -1 && bucket.emiSequenceBreakdown) {
                        bucketStats = bucket.emiSequenceBreakdown.find(item => item.emiSequenceNo === selectedEmiSeq);
                    }

                    if (bucketStats) {
                        stats[key] = {
                            count: bucketStats.count || 0,
                            total_amount: bucketStats.total_amount || 0,
                            total_principal: bucketStats.total_principal || 0,
                            total_interest: bucketStats.total_interest || 0,
                            total_penalty: bucketStats.total_penalty || 0,
                            total_bounce: bucketStats.total_bounce || 0,
                            total_overdue_interest: bucketStats.total_overdue_interest || 0
                        };
                    } else {
                        const totalBounce = bucket.records ? bucket.records.reduce((acc, r) => acc + Number(r.bounce || 0), 0) : 0;
                        stats[key] = {
                            count: bucket.filtered_count !== undefined ? bucket.filtered_count : (bucket.count || 0),
                            total_amount: bucket.total_amount || 0,
                            total_principal: bucket.total_principal || 0,
                            total_interest: bucket.total_interest || 0,
                            total_penalty: bucket.total_penalty || 0,
                            total_bounce: totalBounce,
                            total_overdue_interest: bucket.total_overdue_interest || 0
                        };
                    }
                }
            });

            // Overall stats calculation
            const overallStats = {
                count: 0,
                total_amount: 0,
                total_principal: 0,
                total_interest: 0,
                total_penalty: 0,
                total_bounce: 0,
                total_overdue_interest: 0
            };

            BUCKET_TABS.filter(t => t.key !== "overall").forEach(card => {
                const bStats = stats[card.key];
                overallStats.count += bStats.count;
                overallStats.total_amount += bStats.total_amount;
                overallStats.total_principal += bStats.total_principal;
                overallStats.total_interest += bStats.total_interest;
                overallStats.total_penalty += bStats.total_penalty;
                overallStats.total_bounce += bStats.total_bounce;
                overallStats.total_overdue_interest += bStats.total_overdue_interest;
            });

            stats["overall"] = overallStats;
        }

        return stats;
    }, [apiData, selectedEmiSeq]);

    const selectedStats = useMemo(() => {
        const stats = {
            count: 0,
            total_amount: 0,
            total_principal: 0,
            total_interest: 0,
            total_penalty: 0,
            total_bounce: 0,
            total_overdue_interest: 0
        };

        if (apiData && apiData.agingBuckets) {
            apiData.agingBuckets.forEach(bucket => {
                const key = bucket.dpdBucket;
                if (selectedBuckets.includes(key)) {
                    let bucketStats = null;
                    if (selectedEmiSeq !== -1 && bucket.emiSequenceBreakdown) {
                        bucketStats = bucket.emiSequenceBreakdown.find(item => item.emiSequenceNo === selectedEmiSeq);
                    }

                    if (bucketStats) {
                        stats.count += bucketStats.count || 0;
                        stats.total_amount += bucketStats.total_amount || 0;
                        stats.total_principal += bucketStats.total_principal || 0;
                        stats.total_interest += bucketStats.total_interest || 0;
                        stats.total_penalty += bucketStats.total_penalty || 0;
                        stats.total_bounce += bucketStats.total_bounce || 0;
                        stats.total_overdue_interest += bucketStats.total_overdue_interest || 0;
                    } else {
                        const totalBounce = bucket.records ? bucket.records.reduce((acc, r) => acc + Number(r.bounce || 0), 0) : 0;
                        stats.count += bucket.filtered_count !== undefined ? bucket.filtered_count : (bucket.count || 0);
                        stats.total_amount += bucket.total_amount || 0;
                        stats.total_principal += bucket.total_principal || 0;
                        stats.total_interest += bucket.total_interest || 0;
                        stats.total_penalty += bucket.total_penalty || 0;
                        stats.total_bounce += totalBounce;
                        stats.total_overdue_interest += bucket.total_overdue_interest || 0;
                    }
                }
            });
        }

        return stats;
    }, [apiData, selectedBuckets, selectedEmiSeq]);

    const rawList = useMemo(() => {
        if (!apiData || !apiData.agingBuckets) return [];
        let list = [];
        if (selectedBuckets.includes("overall")) {
            list = apiData.agingBuckets.flatMap(b => 
                (b.records || []).map(r => ({ ...r, dpdBucket: b.dpdBucket }))
            );
        } else {
            list = apiData.agingBuckets
                .filter(b => selectedBuckets.includes(b.dpdBucket))
                .flatMap(b => 
                    (b.records || []).map(r => ({ ...r, dpdBucket: b.dpdBucket }))
                );
        }

        if (selectedEmiSeq !== -1) {
            list = list.filter(r => r.emiSequenceNo === selectedEmiSeq);
        }
        return list;
    }, [apiData, selectedBuckets, selectedEmiSeq]);

    const sequenceBreakdown = useMemo(() => {
        const breakdown = {};

        if (apiData && apiData.agingBuckets) {
            apiData.agingBuckets.forEach(bucket => {
                const key = bucket.dpdBucket;
                if (selectedBuckets.includes("overall") || selectedBuckets.includes(key)) {
                    if (bucket.emiSequenceBreakdown) {
                        bucket.emiSequenceBreakdown.forEach(item => {
                            const seqNo = item.emiSequenceNo;
                            if (!breakdown[seqNo]) {
                                breakdown[seqNo] = {
                                    emiSequenceNo: seqNo,
                                    count: 0,
                                    total_amount: 0,
                                    total_principal: 0,
                                    total_interest: 0,
                                    total_penalty: 0,
                                    total_bounce: 0,
                                    total_overdue_interest: 0
                                };
                            }
                            breakdown[seqNo].count += item.count || 0;
                            breakdown[seqNo].total_amount += item.total_amount || 0;
                            breakdown[seqNo].total_principal += item.total_principal || 0;
                            breakdown[seqNo].total_interest += item.total_interest || 0;
                            breakdown[seqNo].total_penalty += item.total_penalty || 0;
                            breakdown[seqNo].total_bounce += item.total_bounce || 0;
                            breakdown[seqNo].total_overdue_interest += item.total_overdue_interest || 0;
                        });
                    }
                }
            });
        }

        return Object.values(breakdown).sort((a, b) => a.emiSequenceNo - b.emiSequenceNo);
    }, [apiData, selectedBuckets]);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = rawList.slice(indexOfFirstItem, indexOfLastItem);

    const categories = useMemo(() => BUCKET_TABS.filter(t => t.key !== "overall"), []);
    const overallTab = useMemo(() => BUCKET_TABS.find(t => t.key === "overall"), []);

    return (
        <>
            <style dangerouslySetInnerHTML={{ __html: cssStyles }} />

            {popupState ? <Popup popupStatus={popupStatus} closePopup={removePopup} /> : ''}

            {viewPage === false ? (
                <div className="container-fluid overdue-emi-dashboard">
                    {loaderState ? <Loader /> : ""}

                    <div className="dashboard-header-container">
                        <div className="dashboard-title-area">
                            <div className="dashboard-title-icon">
                                <i className="fa fa-clock-o" aria-hidden="true" />
                            </div>
                            <div>
                                <h3 className="dashboard-title">Overdue EMI</h3>
                                <p className="dashboard-subtitle">Manage and track outstanding customer payments by DPD buckets</p>
                            </div>
                        </div>
                    </div>

                    <div className="filter-card">
                        <div className="row">
                            <div className="col-sm-3 col-xs-12">
                                <label>Start Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={startDateToShow}
                                    onChange={(e) => handleDate(e.target.value, 'start')}
                                    id="customDateInput"
                                />
                            </div>
                            <div className="col-sm-3 col-xs-12">
                                <label>End Date</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={endDateToShow}
                                    onChange={(e) => handleDate(e.target.value, 'end')}
                                    id="customDateInput"
                                />
                            </div>
                            <div className="col-sm-6 col-xs-12">
                                <div style={{ display: 'flex', gap: '12px' }}>
                                    <button className="action-btn filter-btn" onClick={() => filterData()}>
                                        <i className="fa fa-filter" aria-hidden="true" /> Filter
                                    </button>
                                    <button className="action-btn download-btn" onClick={downloaddReport}>
                                        <i className="fa fa-download" aria-hidden="true" /> Download Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {apiData && (
                        <div className="summary-table-container">
                            <table className="summary-table">
                                <thead>
                                    <tr>
                                        <th>Category</th>
                                        <th className="text-center">Total Amount</th>
                                        <th className="text-center">Principal</th>
                                        <th className="text-center">Interest</th>
                                        <th className="text-center">Penalty</th>
                                        <th className="text-center">Bounce</th>
                                        <th className="text-center">Total Overdue Interest</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {categories.map((card, ci) => {
                                        const stats = displayStats[card.key] || {
                                            count: 0,
                                            total_amount: 0,
                                            total_principal: 0,
                                            total_interest: 0,
                                            total_penalty: 0,
                                            total_bounce: 0,
                                            total_overdue_interest: 0,
                                        };
                                        const isActive = selectedBuckets.includes(card.key);

                                        return (
                                            <tr
                                                key={ci}
                                                className={`summary-table-row ${isActive ? 'row-active' : ''}`}
                                                style={isActive ? {
                                                    '--active-color': card.color,
                                                    '--active-bg-color': `${card.bg}55`
                                                } : {}}
                                                onClick={() => toggleBucket(card.key)}
                                            >
                                                <td>
                                                    <div className="summary-category-cell">
                                                        <div className="summary-icon-wrapper" style={{ backgroundColor: card.color }}>
                                                            <i className={`fa ${card.icon}`} aria-hidden="true"></i>
                                                        </div>
                                                        <span style={{ color: isActive ? card.color : '#1e293b', fontWeight: isActive ? '700' : '600' }}>{card.label}</span>
                                                        <span className="summary-cnt-badge">{fmtCnt(stats.count)} txns</span>
                                                        {isActive && (
                                                            <span className="summary-viewing-badge">
                                                                <i className="fa fa-check" aria-hidden="true" /> Selected
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.total_amount)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.total_principal)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.total_interest)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.total_penalty)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.total_bounce)}</span>
                                                    </div>
                                                </td>
                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: isActive ? '700' : '600' }}>₹ {fmtINR(stats.total_overdue_interest)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })}

                                    {selectedBuckets.length > 1 && !selectedBuckets.includes("overall") && (() => {
                                        return (
                                            <tr
                                                className="summary-table-row selected-total-row"
                                                style={{ backgroundColor: '#f0fdf4', borderTop: '2px solid #22c55e', borderBottom: '2px solid #22c55e' }}
                                            >
                                                <td>
                                                    <div className="summary-category-cell">
                                                        <div className="summary-icon-wrapper" style={{ backgroundColor: '#22c55e' }}>
                                                            <i className="fa fa-calculator" aria-hidden="true"></i>
                                                        </div>
                                                        <span style={{ color: '#15803d', fontWeight: '700' }}>Selected Total</span>
                                                        <span className="summary-cnt-badge" style={{ backgroundColor: '#dcfce7', color: '#166534' }}>{fmtCnt(selectedStats.count)} txns</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700', color: '#15803d' }}>₹ {fmtINR(selectedStats.total_amount)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700', color: '#15803d' }}>₹ {fmtINR(selectedStats.total_principal)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700', color: '#15803d' }}>₹ {fmtINR(selectedStats.total_interest)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700', color: '#15803d' }}>₹ {fmtINR(selectedStats.total_penalty)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700', color: '#15803d' }}>₹ {fmtINR(selectedStats.total_bounce)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700', color: '#15803d' }}>₹ {fmtINR(selectedStats.total_overdue_interest)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })()}

                                    {overallTab && (() => {
                                        const card = overallTab;
                                        const stats = displayStats[card.key] || {
                                            count: 0,
                                            total_amount: 0,
                                            total_principal: 0,
                                            total_interest: 0,
                                            total_penalty: 0,
                                            total_bounce: 0,
                                            total_overdue_interest: 0
                                        };
                                        const isActive = selectedBuckets.includes(card.key);

                                        return (
                                            <tr
                                                className={`summary-table-row total-row ${isActive ? 'row-active' : ''}`}
                                                style={isActive ? {
                                                    '--active-color': card.color,
                                                    '--active-bg-color': `${card.bg}55`
                                                } : {}}
                                                onClick={() => toggleBucket(card.key)}
                                            >
                                                <td>
                                                    <div className="summary-category-cell">
                                                        <div className="summary-icon-wrapper" style={{ backgroundColor: card.color }}>
                                                            <i className={`fa ${card.icon}`} aria-hidden="true"></i>
                                                        </div>
                                                        <span style={{ color: isActive ? card.color : '#1e293b', fontWeight: '700' }}>{card.label}</span>
                                                        <span className="summary-cnt-badge">{fmtCnt(stats.count)} txns</span>
                                                        {isActive && (
                                                            <span className="summary-viewing-badge">
                                                                <i className="fa fa-check" aria-hidden="true" /> Selected
                                                            </span>
                                                        )}
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.total_amount)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.total_principal)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.total_interest)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.total_penalty)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.total_bounce)}</span>
                                                    </div>
                                                </td>

                                                <td className="text-center">
                                                    <div className="summary-metric-val-row">
                                                        <span className="summary-val" style={{ fontWeight: '700' }}>₹ {fmtINR(stats.total_overdue_interest)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    })()}
                                </tbody>
                            </table>
                        </div>
                    )}

                    {apiData && !selectedBuckets.includes("overall") && sequenceBreakdown.length > 0 && (
                        <div className="sequence-breakdown-container" style={{ marginTop: '24px', marginBottom: '32px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                <i className="fa fa-list-ol" style={{ color: '#ef4444', fontSize: '18px' }} />
                                <h4 style={{ margin: 0, fontSize: '16px', fontWeight: '800', color: '#1e293b' }}>
                                    EMI Sequence Breakdown
                                </h4>
                                <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '500' }}>
                                    (Click a sequence row to filter records)
                                </span>
                            </div>
                            <div className="summary-table-container">
                                <table className="summary-table">
                                    <thead>
                                        <tr>
                                            <th>Sequence</th>
                                            <th className="text-center">Total Amount</th>
                                            <th className="text-center">Principal</th>
                                            <th className="text-center">Interest</th>
                                            <th className="text-center">Penalty</th>
                                            <th className="text-center">Bounce</th>
                                            <th className="text-center">Total Overdue Interest</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {sequenceBreakdown.map((item, idx) => {
                                            const isSeqActive = selectedEmiSeq === item.emiSequenceNo;
                                            return (
                                                <tr
                                                    key={idx}
                                                    className={`summary-table-row ${isSeqActive ? 'row-active' : ''}`}
                                                    style={isSeqActive ? {
                                                        '--active-color': '#3b82f6',
                                                        '--active-bg-color': '#eff6ff'
                                                    } : {}}
                                                    onClick={() => {
                                                        const nextSeq = isSeqActive ? -1 : item.emiSequenceNo;
                                                        setSelectedEmiSeq(nextSeq);
                                                        filterData(nextSeq);
                                                    }}
                                                >
                                                    <td>
                                                        <div className="summary-category-cell">
                                                            <div className="summary-icon-wrapper" style={{ backgroundColor: isSeqActive ? '#3b82f6' : '#64748b', width: '24px', height: '24px', fontSize: '10px' }}>
                                                                #{item.emiSequenceNo}
                                                            </div>
                                                            <span style={{ color: isSeqActive ? '#3b82f6' : '#1e293b', fontWeight: isSeqActive ? '700' : '600' }}>
                                                                EMI {item.emiSequenceNo}
                                                            </span>
                                                            <span className="summary-cnt-badge">{fmtCnt(item.count)} txns</span>
                                                            {isSeqActive && (
                                                                <span className="summary-viewing-badge" style={{ backgroundColor: '#3b82f6', boxShadow: '0 2px 4px rgba(59, 130, 246, 0.15)' }}>
                                                                    <i className="fa fa-filter" aria-hidden="true" /> Filtered
                                                                </span>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="summary-val" style={{ fontWeight: isSeqActive ? '700' : '600' }}>₹ {fmtINR(item.total_amount)}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="summary-val" style={{ fontWeight: isSeqActive ? '700' : '600' }}>₹ {fmtINR(item.total_principal)}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="summary-val" style={{ fontWeight: isSeqActive ? '700' : '600' }}>₹ {fmtINR(item.total_interest)}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="summary-val" style={{ fontWeight: isSeqActive ? '700' : '600' }}>₹ {fmtINR(item.total_penalty)}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="summary-val" style={{ fontWeight: isSeqActive ? '700' : '600' }}>₹ {fmtINR(item.total_bounce)}</span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="summary-val" style={{ fontWeight: isSeqActive ? '700' : '600' }}>₹ {fmtINR(item.total_overdue_interest)}</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}

                    {rawList && rawList.length > 0 ? (
                        <div className="payments-table-container">
                            <div className="tablesconf">
                                <table>
                                    <thead>
                                        <tr>
                                            <th className="text-center">Details</th>
                                            <th className="text-center">Application Id</th>
                                            <th className="text-center">
                                                <div style={{ display: 'flex', gap: '4px', alignItems: 'center', whiteSpace: 'nowrap', justifyContent: 'center' }}>
                                                    Due Date
                                                    <ChevronsUpDown style={{ width: '14px', height: '14px', cursor: 'pointer' }} onClick={() => handleOrderss("dueDate", currentOrder?.order === "desc" ? "asc" : "desc")} />
                                                </div>
                                            </th>
                                            <th className="text-center">Amount</th>
                                            <th className="text-center">Penalty</th>
                                            <th className="text-center">Principal</th>
                                            <th className="text-center">Interest</th>
                                            <th className="text-center">Bounce</th>
                                            <th className="text-center">Overdue Interest</th>
                                            <th className="text-center">
                                                <div style={{ display: 'flex', gap: '4px', alignItems: 'center', whiteSpace: 'nowrap', justifyContent: 'center' }}>
                                                    Overdue Days
                                                    <ChevronsUpDown style={{ width: '14px', height: '14px', cursor: 'pointer' }} onClick={() => handleOrderss("overdueDays", currentOrder?.order === "desc" ? "asc" : "desc")} />
                                                </div>
                                            </th>
                                            {(selectedBuckets.includes("overall") || selectedBuckets.length > 1) && <th className="text-center">DPD Bucket</th>}
                                            <th className="text-center">Tenure</th>
                                            <th className="text-center">EMI Seq No</th>
                                            <th className="text-center">Projected Overdue</th>
                                            <th className="text-center">Processing Fee</th>
                                            <th className="text-center">Status</th>
                                            <th className="text-center">Expected Date</th>
                                            <th className="text-center">Payment Expectancy</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentData.map((data, index) => (
                                            <tr key={index}>
                                                <td className="text-center">
                                                    <div className="info-btn" onClick={() => userDetailHandler(data)}>
                                                        <i className="fa fa-info"></i>
                                                    </div>
                                                </td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.applicationId}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.emi_due_date ? moment(data.emi_due_date).format('DD-MM-YYYY') : "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>₹ {data?.amount ? fmtINR(data.amount) : "0.00"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>₹ {data?.penalty ? fmtINR(data.penalty) : "0.00"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>₹ {data?.principal ? fmtINR(data.principal) : "0.00"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>₹ {data?.interest ? fmtINR(data.interest) : "0.00"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.bounce ? `₹ ${fmtINR(data.bounce)}` : "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.overdueInterest ? `₹ ${fmtINR(data.overdueInterest)}` : "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.overdue_days ?? 0}</td>
                                                {(selectedBuckets.includes("overall") || selectedBuckets.length > 1) && (
                                                    <td className="text-center">
                                                        <span className="bucket-tag" style={getBucketStyles(data?.dpdBucket)}>
                                                            {data?.dpdBucket} DPD
                                                        </span>
                                                    </td>
                                                )}
                                                <td className="text-center">
                                                    {data?.loanEmi ? (
                                                        <span className="tenure-tag">
                                                            {data.loanEmi}
                                                        </span>
                                                    ) : "-"}
                                                </td>
                                                <td className="text-center">{data?.emiSequenceNo ?? "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.predictedOverdueAmount ? `₹ ${fmtINR(data.predictedOverdueAmount)}` : "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>₹ {data?.processing_fee ? fmtINR(data.processing_fee) : "0.00"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.status ?? "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.expectedDate ? moment(data.expectedDate).format('DD-MM-YYYY') : "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{data?.paymentExpectancy ? `${data.paymentExpectancy}%` : "-"}</td>
                                                <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                                                    <div style={{ display: 'flex', gap: '8px', alignItems: 'center', justifyContent: 'center' }}>
                                                        <div className="edit-btn" onClick={(e) => EditData(e, data)} title="Edit Details">
                                                            <i className="fa fa-pencil-square-o" aria-hidden="true"></i>
                                                        </div>
                                                        <div className="generate-btn" onClick={(e) => handleGeneratePopup(data)}>
                                                            <i className="fa fa-link" aria-hidden="true" /> Generate Link
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="pagination-bar" style={{ paddingBottom: '10px' }}>
                                <div className="pagination-info" style={{ paddingLeft: '10px' }}>
                                    Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, rawList.length)} of {fmtCnt(rawList.length)} records
                                </div>
                                <Pagination
                                    count={Math.ceil(rawList.length / itemsPerPage)}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="primary"
                                />
                            </div>
                        </div>
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '60px' }}>
                            <img src={NodataImage} style={{ width: '25%', opacity: 0.6 }} alt="No data available" />
                            <p style={{ marginTop: '16px', color: '#64748b', fontSize: '15px', fontWeight: '500' }}>No overdue EMI records found for the selected filter.</p>
                        </div>
                    )}
                </div>
            ) : ""}

            {popupdata.show ? (
                <div className="background-blur overdue-emi-popup">
                    <div className="popup-main small-popup container-fluid max-width-600px dbl-border premium-popup">
                        <i onClick={() => closePopup()} className="fa fa-times-circle premium-popup-close"></i>

                        <div className="row">
                            <div className="col-xs-12" style={{ marginBottom: '15px' }}>
                                <h4 className="popup-title text-center">Update Overdue Details</h4>
                                <div style={{ fontSize: '13px', fontWeight: '600', color: '#64748b', textAlign: 'center' }}>
                                    Application ID: {popupdata?.data?.applicationId}
                                </div>
                            </div>

                            <div className="col-sm-4 col-xs-12 popup-field-col">
                                <label className="popup-field-label">Status</label>
                                <input
                                    className='form-control'
                                    type="text"
                                    placeholder='Enter Status'
                                    value={editableFields.status}
                                    name="status"
                                    onChange={(e) => handleEditChange(e)}
                                />
                            </div>

                            <div className="col-sm-4 col-xs-12 popup-field-col">
                                <label className="popup-field-label">Expected Date</label>
                                <input
                                    className='form-control'
                                    type="date"
                                    name="expectedDate"
                                    value={editableFields.expectedDate}
                                    onChange={(e) => handleEditChange(e)}
                                />
                            </div>

                            <div className="col-sm-4 col-xs-12 popup-field-col">
                                <label className="popup-field-label">Expectancy (%)</label>
                                <input
                                    className='form-control'
                                    type="number"
                                    min={0}
                                    max={100}
                                    name="paymentExpectancy"
                                    value={editableFields.paymentExpectancy}
                                    onChange={(e) => handleEditChange(e)}
                                />
                            </div>

                            <div className="col-xs-12" style={{ marginTop: '24px' }}>
                                <div className="text-center">
                                    <button className="popup-submit-btn" onClick={() => updateDetails()}>
                                        Update Details
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : ""}

            {
                showgenerateLinkPopup ?
                    <GenerateLink
                        userDetail={generateLinkPopup?.userDetail}
                        admin={admin}
                        emiDetail={generateLinkPopup?.emiData}
                        openGenerateLink={handleGenerateLinkPopup}
                        tenant={tenant}
                    />
                    : ""}
        </>
    );
};

export default OverDueEmi;
